/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ValidateTapToPayPolicyRequest} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/client_service.pb'
import {ValidateTapToPayPolicyResponse} from '@cash-web/protos/squareup/cash/cashbusinesspayments/api/v1beta1/client_service.pb'


export const validateTapToPayPolicy = (request:ValidateTapToPayPolicyRequest, options?: CashRequestOptions) => post<ValidateTapToPayPolicyRequest, ValidateTapToPayPolicyResponse>("/2.0/cash/validate-tap-to-pay-policy", request, {...options, rejectOnError: true })